// TODO(bisem): Change to '--' once we can migrate all of CDM to reference this constant instead of hardcoding
export const DEFAULT_DISPLAY_VALUE = '..';
